import {
  get,
  post,
  del,
  put
} from '@/util/request'

//新增
export const InsertUser = (data) =>{
 return post('/api/app/user',data);

} 
//修改
export const UpdateUser = (data) =>{
  return put('/api/app/user',data);
 } 

//删除by id
export  const DeleteUser=(params)=>{
  return del(`/api/app/user/${params.userId}`);
}

//获取by id
export  const selectByCodeID=(params)=>{
  return get(`/api/app/user?CurrentId=${params.userId}`);
}

//分页
export  const GetUserInfo=(data)=>{
  return post(`/api/app/user/list`,data);
}

//更新状态
export  const UpdataUserState=(params)=>{
  return post(`/api/app/user/upataUserStateById/${params.userId}?state=${params.state}`);
}
//更新密码
export  const UpdataUserPossword=(params,data)=>{
  return post(`/api/app/user/upataUserEnclosureById/${params.userId}`,data);
}


export  const DownLoadExcelTemplateFile=(params)=>{
  return get('/api/User/DownLoadExcelTemplateFile',{},{});
}




